<div class="parking-agents-container">
    <div class="container-fluid">
        <div class="row g-6 mb-6">
        </div>
        <div class="table-container">
            <div class="d-flex justify-content-between align-items-center parking-agents-title">
                <h5>Agenți de parcare</h5>
                <div class="text-end">
                    <button class="btn btn-sm btn-neutral btn-add-user" (click)="openDialog()">Adaugă un agent nou
                    </button>
                </div>
            </div>
            <div class="table-responsive">
                <table datatable [dtOptions]="dtOptions" class="table table-hover table-nowrap parking-agents-table">
                    <thead class="thead-light">
                        <tr>
                            <th scope="col" (click)="sortTable('firstName')">Nume</th>
                            <th scope="col" (click)="sortTable('lastName')">Prenume</th>
                            <th scope="col" (click)="sortTable('email')">E-mail</th>
                            <th scope="col">Numărul de bilete scanate astăzi</th>
                            <th scope="col">Numărul de amenzi date astăzi</th>
                            <th scope="col">Acțiuni</th>
                        </tr>
                    </thead>
                </table>
            </div>
        </div>
    </div>
</div>
